/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContractFilterInnerV2Dto } from '../models/ContractFilterInnerV2Dto';
import type { OrderByRelationalPropertyDto } from '../models/OrderByRelationalPropertyDto';
import type { TicketFilterInnerV2Dto } from '../models/TicketFilterInnerV2Dto';
import type { TicketStatusAlert } from '../models/TicketStatusAlert';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExportDataService {
  /**
   * Download contract csv.
   * Download contract csv from the storage.
   * @param fields List of properties for ContractExportDataDto to include in the exported data
   * @param actionsAvailable Indicates if there are actions available for the contract
   * @param customerId Filter contracts by customer ID
   * @param customerGroupId Filter contracts by customer group ID
   * @param partnerId Filter contracts by partner ID
   * @param partnerGroupId Filter contracts by partner group ID
   * @param pointOfSaleId Filter contracts by point of sale ID
   * @param filter Filter conditions for querying Point of Sales
   * @param orderBy Array of ContractBaseV2Dto order by properties (supports relations with dot-notation)
   * @param limit Number of items per page. Must be between 5 and 500. Used for paginated queries.
   * @returns binary
   * @throws ApiError
   */
  public static exportDataControllerDownloadContractsExportDataV1(
    fields: Array<
      | 'id'
      | 'createdAt'
      | 'modifiedAt'
      | 'name'
      | 'startDate'
      | 'endDate'
      | 'handOverDate'
      | 'contractType'
      | 'contractTypeId'
      | 'actionStart'
      | 'supposedActionEnd'
      | 'lastPossibleContractEnd'
      | 'contractAction'
      | 'contractingParties'
      | 'payments'
      | 'contractConditions'
      | 'areas'
    >,
    actionsAvailable?: boolean | null,
    customerId?: string | null,
    customerGroupId?: string | null,
    partnerId?: string | null,
    partnerGroupId?: string | null,
    pointOfSaleId?: string | null,
    filter?: ContractFilterInnerV2Dto | null,
    orderBy?: Array<OrderByRelationalPropertyDto> | null,
    limit?: number,
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/export-data/contracts',
      query: {
        fields: fields,
        actionsAvailable: actionsAvailable,
        customerId: customerId,
        customerGroupId: customerGroupId,
        partnerId: partnerId,
        partnerGroupId: partnerGroupId,
        pointOfSaleId: pointOfSaleId,
        filter: filter,
        orderBy: orderBy,
        limit: limit,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * Download ticket csv.
   * Download ticket csv from the storage.
   * @param fields List of properties for TicketExportDataDto to include in the exported data
   * @param orderBy Array of TicketV2Dto order by properties (supports relations with dot-notation)
   * @param filter Filter conditions for querying Tickets
   * @param statusAlert Ticket status alert filter. NEW, IN_PROGRESS and CLOSED are payload statuses. ALL_OPEN, IN_TIME and IN_FOCUS are filter-only values; IN_PROGRESS is also used as the yellow in-progress filter bucket.
   * @param customerGroupId Customer group ID to filter tickets by
   * @param customerId Customer ID to filter tickets by
   * @param limit Number of items per page. Must be between 5 and 500. Used for paginated queries.
   * @returns binary
   * @throws ApiError
   */
  public static exportDataControllerDownloadTicketsExportDataV1(
    fields: Array<
      | 'assignee'
      | 'createdAt'
      | 'customerCode'
      | 'customerGroupId'
      | 'customerGroupName'
      | 'customerId'
      | 'customerName'
      | 'id'
      | 'modifiedAt'
      | 'name'
      | 'number'
      | 'pointOfSaleId'
      | 'pointOfSaleName'
      | 'processStepName'
      | 'status'
    >,
    orderBy?: Array<OrderByRelationalPropertyDto> | null,
    filter?: TicketFilterInnerV2Dto | null,
    statusAlert?: TicketStatusAlert,
    customerGroupId?: string,
    customerId?: string,
    limit?: number,
  ): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/export-data/tickets',
      query: {
        fields: fields,
        orderBy: orderBy,
        filter: filter,
        statusAlert: statusAlert,
        customerGroupId: customerGroupId,
        customerId: customerId,
        limit: limit,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param domain The domain for which to retrieve available fields
   * @returns string Returns the list of available fields for export.
   * @throws ApiError
   */
  public static exportDataControllerGetAvailableFieldsForExportV1(
    domain: 'ticket' | 'contract',
  ): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/export-data/fields',
      query: {
        domain: domain,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
